const DiscreteMathIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">

        <h1 className="tw-header font-bold text-gray-900 mb-4">Discrete Maths</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Discrete mathematics is the math of individual elements — things you can count, list, or structure.
                It’s not about continuous curves or calculus, but rather logic, sets, graphs, and algorithms.
                If you’ve ever worked with if/else logic, made a decision tree, or studied how websites link to each other,
                you’ve already touched discrete math.
            </p>
            <p className="text-gray-600 tw-subtitle text-justify">
                It plays a huge role in computer science, cryptography, network design, and AI.
                From how search engines rank results, to how machines reason through complex problems —
                discrete math provides the tools to work with structure, logic, and order.
            </p>
            <p className="text-gray-600 tw-subtitle text-justify">
                This section will walk through the essentials like logic gates, combinatorics, graph theory,
                and more — all broken down into digestible pieces with practical examples.
            </p>
        </div>
    );
}

export default DiscreteMathIntro;
